<div class="find-acc-container">
  <mat-card class="find-acc-form-container">
    <form class="find-acc-form" [formGroup]="_form" (ngSubmit)="find_acc()">
      <!-- Label -->
      <div class="find-acc-title">
        <ddc-text-gradient class="text-xl" [_text]="_pageCardTitle" [_type]="'1'"> </ddc-text-gradient>
        <p class="text-1xl font-bold">{{ _pageCardText }}</p>
      </div>
      <!-- ! Form Error -->
      @if (_form.errors) {
        <div class="alert alert-danger">
          {{ _findAccError }}
        </div>
      }
      <!-- ! Username or Email -->
      @if (!_accountFound) {
        <mat-form-field class="find-acc-code">
          <mat-label>Username or Email</mat-label>
          <input formControlName="_username_or_email" matInput placeholder="Ex. mike_s96" />
          <!-- * Errors -->
          @if (username_or_email.hasError('required')) {
            <mat-error> Username is <strong>required</strong> </mat-error>
          }
          @if (username_or_email.hasError('minlength')) {
            <mat-error>
              At least <strong>{{ _minLength }}</strong> characters.
            </mat-error>
          }
          @if (username_or_email.hasError('maxlength')) {
            <mat-error>
              Maximum <strong>{{ _maxLength }}</strong> characters.
            </mat-error>
          }
        </mat-form-field>
      }
      <!-- ! Submit button -->
      @if (!_accountFound) {
        <ddc-button-s-one
          [_icon]="'person_search'"
          [_isLoading]="_isFindAccBtnLoading"
          [_label]="_submitBtnText"
        ></ddc-button-s-one>
      }
    </form>
    @if (_accountFound && !_resetPasswordEmailSent) {
      <button mat-stroked-button [disabled]="_isSendResetPasswordEmailBtnLoading" (click)="sendResetPasswordEmail()">
        @if (_isSendResetPasswordEmailBtnLoading) {
          <i class="material-icons">person_search</i>
        }
        {{ _sendResetPasswordEmailBtnText }}
      </button>
    }
    <mat-divider></mat-divider>
    <!-- To Login -->
    <div class="find-acc-find-acc">
      <!-- ! Route -->
      <ddc-button-r-one
        class="find-acc-find-acc-button"
        [dynamicRoute]="'/signup'"
        [icon]="'how_to_reg'"
        [label]="'Not registered? Sign up!'"
        [type]="'route'"
      >
      </ddc-button-r-one>
    </div>
  </mat-card>
</div>
